import React, { createContext, useContext, useState } from 'react';
import ToastNotification from '../components/ToastNotification';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    visible: false,
    message: '',
    type: 'info',
    avatarUrl: null,
  });

  const showToast = (message, type = 'info', options = {}) => {
    setToast({
      visible: true,
      message,
      type,
      avatarUrl: options.avatarUrl || null,
    });
  };

  const hideToast = () => {
    setToast({
      ...toast,
      visible: false,
    });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastNotification
        message={toast.message}
        type={toast.type}
        avatarUrl={toast.avatarUrl}
        visible={toast.visible}
        onDismiss={hideToast}
      />
    </ToastContext.Provider>
  );
};

